import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-md" }

import {computed, onMounted} from 'vue';
import {useMainStore} from 'stores/main';
import BusinessServiceTreeElement from 'src/apps/business/components/BusinessServiceTreeElement.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessServiceTable',
  props: {
  business: {
    type: Object,
    required: true
  }
},
  setup(__props) {


const props = __props

const servicesIds = computed(() => {
  if (props.business.services) {
    return props.business.services.map((service) => service.id)
  }
  return []
})

const mainStore = useMainStore()

function filterActiveNodes(node, activeServices) {
  // Check if the current node is active or has active children
  if (activeServices.includes(node.id)) {
    return {
      ...node,
      children: node.children
        .map((child) => filterActiveNodes(child, activeServices))
        .filter(Boolean),
    };
  } else if (node.children && node.children.length > 0) {
    const activeChildren = node.children
      .map((child) => filterActiveNodes(child, activeServices))
      .filter(Boolean);
    if (activeChildren.length > 0) {
      return {
        ...node,
        children: activeChildren,
      };
    }
  }
  return null;
}

const activeServices = computed(() => {
  let _activeServices: any = []
  mainStore.businessServices.forEach((node) => {
    const nodes = filterActiveNodes(node, servicesIds.value)
    if (nodes) {
      _activeServices.push(nodes)
    }
  })
  return _activeServices
})

onMounted(() => {
  mainStore.fetchBusinessServices()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeServices.value, (service) => {
      return (_openBlock(), _createBlock(BusinessServiceTreeElement, {
        key: service.id,
        service: service
      }, null, 8, ["service"]))
    }), 128))
  ]))
}
}

})